import logo_telec from '../img/logo.png';

const Homepage = () => (
    <section id="accueil" className="bg-custom-bg min-h-[90vh] py-10">
        <div className="flex justify-center">
            <img
                className="max-w-[240px] w-full"
                src={logo_telec}
                alt="T.ELEC - Électricien à Nancy"
            />
        </div>

        <div className="flex justify-center">
            <div className="my-10 py-10 px-6 bg-light-background dark:bg-dark-background w-11/12 md:w-2/3 lg:w-1/2">
                <h1 className="text-3xl mb-5 text-center text-light-text dark:text-dark-text">
                    Électricien à Nancy et alentours
                </h1>

                <p className="text-center text-light-text dark:text-dark-text mb-6">
                    T.ELEC intervient à Nancy pour vos travaux d’électricité, dépannage, rénovation et installations techniques.
                    Nous accompagnons les particuliers et professionnels avec des solutions fiables, certifiées et durables.
                </p>

                <ul className="space-y-3 text-center text-light-text dark:text-dark-text">
                    <li>Dépannage électrique à Nancy</li>
                    <li>Installation et rénovation électrique</li>
                    <li>Motorisation de portail</li>
                    <li>Interphone et visiophone</li>
                    <li>Domotique</li>
                    <li>Borne de recharge voiture électrique IRVE</li>
                    <li>Panneaux solaires</li>
                </ul>

                <p className="text-center text-light-text dark:text-dark-text pt-8">
                    SARL T.ELEC intervient à Nancy et dans un rayon d’environ 20 km :
                    Seichamps, Essey-lès-Nancy, Saint-Max, Tomblaine, Pulnoy,
                    Saulxures-lès-Nancy, Jarville-la-Malgrange, Laneuveville-devant-Nancy,
                    Vandœuvre-lès-Nancy et Laxou.
                </p>

                <div className="mt-8 flex justify-center">
                    <a
                        href="#devis"
                        className="inline-block rounded bg-blue-600 px-5 py-3 text-white font-semibold hover:bg-blue-700 transition"
                    >
                        Demander un devis
                    </a>
                </div>
            </div>
        </div>
    </section>
);

export default Homepage;